import { useState } from "react";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import CampoTextoLongo from "../Campo/CampoTextoLongo";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import CampoNumber from "../Campo/CampoNumber";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import CampoSelect from "../Campo/CampoSelect";

type Props = {
  refMeta?: MetaAplicacao;
  closeModal: Function;
  list: MetaAplicacao[];
  setList: Function;
  listaMetas: MetaFisica[];
  tipo: string;
  index?: number;
};

const ModalMetaAplicacao = ({
  refMeta,
  closeModal,
  list,
  setList,
  listaMetas,
  tipo,
  index,
}: Props) => {
  const [valorOrgao, setOrgao] = useState(refMeta?.valor_orgao_entidade || 0);
  const [valorOSC, setOSC] = useState(
    refMeta?.valor_organizacao_sociedade_civil || 0
  );
  const [metaFisica, setMetaFisica] = useState(
    refMeta?.meta_execucao_fisico_id || 0
  );
  const [especificacao, setEspecificacao] = useState(
    refMeta?.especificacao || ""
  );

  return (
    <form className={styles.formModal}>
      <h2>Criar Meta de Aplicação</h2>

      <CampoSelect
        title="Meta Fisica"
        setter={setMetaFisica}
        value={metaFisica}
      >
        {listaMetas &&
          listaMetas.map((metaFisica, index) => (
            <option value={index} key={index}>
              {`${metaFisica.etapa}.${
                metaFisica.fase
              } - ${metaFisica.descricao.substring(0, 70)}${
                metaFisica.descricao.length > 70 ? "..." : ""
              }`}
            </option>
          ))}
      </CampoSelect>

      <CampoTextoLongo
        title="Especificação - CORRENTE"
        placeholder="Especifique a aplicação corrente"
        required={true}
        customValidity="Preencha com a Especificação da aplicação corrente"
        setter={setEspecificacao}
        value={especificacao}
      />
      <div className={styles.gridCampos}>
        <CampoNumber
          title="Órgão/Entidade R$"
          step={0.25}
          customValidity="Preencha com o Órgão/Entidade Financiador"
          setter={setOrgao}
          value={valorOrgao}
        />

        <CampoNumber
          title="Organização Sociedade Civil"
          customValidity="Preencha com o nome da OSC"
          setter={setOSC}
          value={valorOSC}
        />
      </div>
      <hr className={styles.separador} />
      {!refMeta && (
        <input
          type="submit"
          value="+ Adicionar Meta"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            if (VerificaForm(e.currentTarget.form)) {
              const item: MetaAplicacao = {
                meta_execucao_fisico_id: metaFisica,
                valor_orgao_entidade: valorOrgao,
                valor_organizacao_sociedade_civil: valorOSC,
                especificacao: especificacao,
                tipo: tipo,
              };
              addList({
                item,
                list,
                setList,
              });

              closeModal();
            }
          }}
        />
      )}
      {refMeta !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Meta"
            className={styles.editBtn}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
              if (VerificaForm(e.currentTarget.form)) {
                const item: MetaAplicacao = {
                  meta_execucao_fisico_id: metaFisica,
                  valor_orgao_entidade: valorOrgao,
                  valor_organizacao_sociedade_civil: valorOSC,
                  especificacao: especificacao,
                  tipo: tipo,
                };
                editList({
                  item,
                  setList,
                  list,
                  index,
                });

                closeModal();
              }
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalMetaAplicacao;
